import RescueCode from "./RescueCode";
export default RescueCode;
